import React from 'react';

import Breadcrumbs, { BreadcrumbsItem } from '@atlaskit/breadcrumbs';

import { StorageOfUniqueServices } from '@qality/common-service';
import useProjectDashboardUrl from '@qality/common-utils/src/hooks/useProjectDashboardUrl';

import useGlobalDashboardUrl from './useGlobalDashboardUrl';

interface DashboardBreadcrumbsProps {
  projectName: string;
  projectKey: string;
  projectId: string;
  nameSuffix: string;
}

export const DashboardBreadcrumbs: React.FC<DashboardBreadcrumbsProps> = ({
  projectKey,
  projectId,
  projectName,
  nameSuffix,
}: DashboardBreadcrumbsProps) => {
  const globalDashboardUrl = useGlobalDashboardUrl();
  const projectDashboardUrl = useProjectDashboardUrl(projectKey, projectId);

  return (
    <Breadcrumbs>
      <BreadcrumbsItem
        onClick={() => {
          StorageOfUniqueServices.get('AP').navigator.go('site', {
            absoluteUrl: globalDashboardUrl,
          });
        }}
        text={`QAlity ${nameSuffix}`}
        key={`QAlity ${nameSuffix}`}
      />
      {projectName && (
        <BreadcrumbsItem
          onClick={() => {
            StorageOfUniqueServices.get('AP').navigator.go('site', {
              absoluteUrl: projectDashboardUrl,
            });
          }}
          text={projectName}
          key={projectName}
        />
      )}
      <BreadcrumbsItem text='Dashboard' key='Dashboard' />
    </Breadcrumbs>
  );
};
